// extracted by mini-css-extract-plugin
module.exports = {"container":"dragDrop_container__3odXu","Aside":"dragDrop_Aside__2R5da","fileName":"dragDrop_fileName__19U-O"};